import './App.scss';
import { Amplify } from 'aws-amplify';
import amplifyconfig from './amplifyconfiguration.json';
import { withAuthenticator, } from '@aws-amplify/ui-react';
import { fetchAuthSession } from 'aws-amplify/auth';
import '@aws-amplify/ui-react/styles.css';
import axios from 'axios';

import AuthProvider from './AuthProvider';
import { useEffect, useState } from 'react';
import Biodetails from './components/bio/Biodetails';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import ReimbursementSelect from './components/dropdowns/ReimbursementSelect';
import ViewReimbursements from './components/pages/manager/ViewReimbursements';

import Navbar from './components/navbar/navbar';
import { Route, Router, Routes, useLocation, useNavigate } from 'react-router-dom';
import AccountingEntryPoint from './accounting/AccountingEntryPoint';
import PrivateRoute from './routers/PrivateRoute';
import PrivateRouteManager from './routers/PrivateRouteManager';
import { baseUrl, baseUrl_SPB } from './BaseUrl';
import AddCompany from './components/admin/AddCompany';
import AddCompanyService from './services/AddCompanyService';
import Invite from './components/admin/Invite';
import { IoSettingsOutline } from "react-icons/io5";
import { IoLogoApple } from "react-icons/io5";
import AccountMenu from './account/AccountMenu';
import { Elements, useElements, useStripe } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { PaymentElement } from '@stripe/react-stripe-js';
import Checkout from './stripe/Checkout';
import PurchaseRequestSuccess from './stripe/PurchaseRequestSuccess';
import PlansCard from './stripe/PlansCard';
import OpenSettingsCard from './components/card/OpenSettingsCard';

import * as React from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import CustomerInvoice from './stripe/plans/CustomerInvoice';
import AuthRedirectZepto from './components/zepto/AuthRedirectZepto';
import InvQuoteView from './InvQuote/InvQuoteView';
import ChatView from './chat/ChatView';
import PayslipScreen from './payslip/PayslipScreen';
import PayrunListPage from './payslip/PayrunListPage';
import PayrunDetailPage from './payslip/PayrunDetailPage';
import PayRunTriggerScreen from './payslip/PayRunTriggerScreen';
import XeroPKCEScreen from './components/xero/XeroPKCEScreen';
import XeroCallbackPage from './components/xero/XeroCallbackPage';
import XeroTimesheetExport from './components/xero/TimesheetExport';
import { RosterMainScreen } from './roster/Roster';
import XeroDashboard from './components/xero/XeroDashboard';
import XeroEmployeeImport from './components/xero/XeroEmployeeImport';
import KbChatView from './ai/kb/chat/ChatView';
import AIChatView from './ai/AIChatView';
import InventoryManagement from './inventory/InventoryManagement';
import InventorySearch from './inventory/InventorySearch';
import AddInventory from './inventory/AddInventory';
import AIInventoryCheck from './inventory/AIInventoryCheck';
import CustomerManagement from './customer/CustomerManagement';
import CustomerSearch from './customer/CustomerSearch';
import AddCustomer from './customer/AddCustomer';
import IndDocumentProcessing from './workflow/docprocessing/document-processing';
import TradeJobDashboard from './trade-job/trade-job-dashboard';
import TradeJobCreatePage from './trade-job/views/TradeJobCreatePage';
import TradeJobCalendarPage from './trade-job/TradeJobCalendarPage';
import EmployeeListPage from './components/admin/EmployeeListPage';
import OnboardingHubPage from './onboarding/OnboardingHubPage';
import OnboardingDetailPage from './onboarding/OnboardingDetailPage';
import CompanyDetails from './components/admin/CompanyDetails';
import ManageCompany from './components/admin/ManageCompany';
import CompanyVehicleRegoPage from './components/admin/CompanyVehicleRegoPage';
import CallCenterHomePage from './call-center/CallCenterHomePage';
import AvailableNumbersPage from './call-center/AvailableNumbersPage';
import RequestNumberPage from './call-center/RequestNumberPage';
import PortNumberPage from './call-center/PortNumberPage';
import ChangeNumberPage from './call-center/ChangeNumberPage';
import MyProfilePage from './components/profile/MyProfilePage';
import MyProfileCalendarPage from './components/profile/MyProfileCalendarPage';
import CreateEmploymentJobPage from './flexible-employment/CreateEmploymentJobPage';
import EmployerEmploymentJobsPage from './flexible-employment/EmployerEmploymentJobsPage';
import EmploymentJobApplyPage from './flexible-employment/EmploymentJobApplyPage';
import GuidedTourModal from './guided-tour/GuidedTourModal';
import { consumeGuidedTourLaunch } from './guided-tour/guidedTourStorage';
import TimesheetManager from './roster-timesheet-manager/TimesheetManager';
import XeroConfiguration from './components/xero/company-setting/XeroConfiguration';
import LeaveManager from './home/roster-leave-manager/LeaveManager';
import Location from './roster/Location';
import BasiqConnectScreen from './components/basiq/BasiqConnectScreen';
import StripeConnectScreen from './components/stripe/StripeConnectScreen';
import StripeReturnPage from './components/stripe/StripeConnectCompleteScreen';
import StripeSuccessPage from './accounting/invoice/invoice-payment/StripeSuccessPage';
import StripeCancelPage from './accounting/invoice/invoice-payment/StripeCancelPage';
import FiskilConnectScreen from './accounting/bank/bank-reconcile/fiskil/service/FiskilConnectScreen';

Amplify.configure(amplifyconfig);



export default function App(props) {
  const [additionalUserInfo, setAdditionalUserInfo] = useState({});
  const [role, setRole] = useState('');
  const [token, setToken] = useState('');
  const [showAppDownloadPopup, setShowAppDownloadPopup] = useState(false);
  const [showGuidedTour, setShowGuidedTour] = useState(false);
  const [pageName, setPageName] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const guidedTourUserId = props.user?.username || props.user?.signInDetails?.loginId || additionalUserInfo?.email || 'anonymous';
  const getRole = (role) => {
    setRole(role);
  }

  // Auto-redirect ROLE_NEWU users to the bio setup screen
  useEffect(() => {
    if (role === 'ROLE_NEWU') {
      if (location.pathname.startsWith('/employment-jobs/') && location.pathname.endsWith('/apply')) {
        window.sessionStorage.setItem('postBiodetailsRedirect', `${location.pathname}${location.search || ''}`);
      }
      navigate('/newuser');
    }
  }, [role, location.pathname, location.search, navigate]);

  useEffect(() => {
    if (role && role !== 'ROLE_NEWU' && consumeGuidedTourLaunch(guidedTourUserId)) {
      setShowGuidedTour(true);
    }
  }, [role, location.pathname, guidedTourUserId]);

  const openSection = (pName) => {
    console.log(pName);
    setPageName(pName);
  }
  useEffect(() => {
    fetchAuthSession().then((session) => {
      console.log("HERE CHANGED CODE");
      let tokenv = session.tokens.accessToken.toString();
      setToken(tokenv);
      setLoading(true);
      axios.get(`${baseUrl_SPB}/api/v1/user/me`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + tokenv,

        }
      })
        .then(userDetailsResponse => {
          let response = userDetailsResponse.data;
          setRole(response.role);
          console.log("we set additional info");
          setAdditionalUserInfo(response);
          return response.role;
        })
        .catch(error => {
          console.error('Error fetching user details and role:', error);
          setRole("")
        });
    });

  }, []);
  const determinePage = () => { }
  return (

    <StyledEngineProvider injectFirst>
      <AuthProvider logOut={props.signOut} user={props.user} token={token} role={role} additionalUserInfo={additionalUserInfo} setAdditionalUserInfo={setAdditionalUserInfo} setRole={setRole} loading={loading}>

        <div className="App">

          <div className="rootContainer">
           
            <div className="aside-2">
              <Navbar openSection={openSection} onOpenGuidedTour={() => setShowGuidedTour(true)} />
            </div>
            <div className="wrapper">
              <div className="header">
                <div></div>
                <div></div>
                <div></div>
                <div><AccountMenu signOut={props.signOut} user={props.user} token={token} role={role} additionalUserInfo={additionalUserInfo} setAdditionalUserInfo={setAdditionalUserInfo} setRole={setRole} />

                </div>
              </div>
              <div className="main">
      
                <Routes>
                  {/* Accounting module: manager+ only */}
                  <Route path="/accounting/*" element={<PrivateRouteManager />}>
                    <Route path="*" element={<AccountingEntryPoint />} />
                  </Route>
                  <Route path="/schedule" element={<RosterMainScreen user={props.user} token={token} role={role} additionalUserInfo={additionalUserInfo} setAdditionalUserInfo={setAdditionalUserInfo} setRole={setRole} />} />
 <Route path="/" element={
                    role === 'ROLE_NEWU'
                      ? <ReimbursementSelect determinePage={determinePage} setPageName={setPageName} setAdditionalUserInfo={setAdditionalUserInfo} setRole={setRole} />
                      : <AIChatView/>
                  } />
                  <Route path="/start" element={
                    role === 'ROLE_NEWU'
                      ? <ReimbursementSelect determinePage={determinePage} setPageName={setPageName} setAdditionalUserInfo={setAdditionalUserInfo} setRole={setRole} />
                      : <AIChatView />
                  } />

                  {/* <Route path="/" element={<ReimbursementSelect determinePage={determinePage} setPageName={setPageName} setAdditionalUserInfo={setAdditionalUserInfo} />} /> */}
                  <Route path="/reimburse" element={<ReimbursementSelect determinePage={determinePage} setPageName={setPageName} setAdditionalUserInfo={setAdditionalUserInfo} setRole={setRole} />} />
                  <Route path="/newuser" element={<Biodetails additionalUserInfo={additionalUserInfo} setAdditionalUserInfo={setAdditionalUserInfo} setRole={setRole} user={props.user} />} />
                  <Route path="/biodetails" element={<Biodetails />} />
                  <Route exact path="/privacy" render={() => { window.location.href = "terminos.html" }} />
                  <Route exact path="/subsuccess" element={<div><PurchaseRequestSuccess token={token} /></div>} />
                  <Route path="/subfail" element={<div>Subscription fail</div>} />
                  <Route path="/subfail2" element={<div>Subscription fail</div>} />
                  <Route path="/zauthc" element={<AuthRedirectZepto />} />
                  <Route exact path="/" element={<PrivateRouteManager />}>
                    <Route path="/invoices" element={<CustomerInvoice />} />
                    <Route path="/addcompany" element={<AddCompany />} />
                    <Route path="/managecompany" element={<ManageCompany />} />
                    <Route path="/company" element={<CompanyDetails />} />
                    <Route path="/company/vehicle-rego" element={<CompanyVehicleRegoPage />} />
                    <Route path="/invite" element={<Invite />} />
                    <Route path="/employees" element={<EmployeeListPage />} />
                    <Route path="/onboarding" element={<OnboardingHubPage />} />
                    <Route path="/payslip" element={<PayslipScreen />} />
                    <Route path="/payrunlist" element={<PayrunListPage additionalUserInfo={additionalUserInfo} />} />
                    <Route path="/payruntrigger" element={<PayRunTriggerScreen additionalUserInfo={additionalUserInfo} />} />
                    <Route path="/payrun/:id" element={<PayrunDetailPage />} />
                    <Route path="/xeroconnet" element={<XeroPKCEScreen />} />
                    
                    

                    <Route path="/xerodashboard" element={<XeroDashboard />} />
                    <Route path="/xerotimesheetexport" element={<XeroTimesheetExport additionalUserInfo={additionalUserInfo} />} />
                    <Route path="/xeroemployeeimport" element={<XeroEmployeeImport additionalUserInfo={additionalUserInfo} />} />
                    <Route path="/xero/callback" element={<XeroCallbackPage />} />
                    <Route path="/xeroconfiguration" element={<XeroConfiguration />} />
                      <Route path="/basiqconnect" element={<BasiqConnectScreen />} />
                      <Route path="/fiskilconnect" element={<FiskilConnectScreen />} />
                    
                    <Route path="/stripeconnect" element={<StripeConnectScreen />} />
                    <Route path="/stripe/complete" element={<StripeReturnPage />} />
                    <Route path="/invoice/stripe/payment/success" element={<StripeSuccessPage />} />
                    <Route path="/invoice/stripe/payment/cancel" element={<StripeCancelPage />} />
                    
                    <Route path="/callcenter" element={<CallCenterHomePage />} />
                    <Route path="/callcenter/numbers" element={<AvailableNumbersPage />} />
                    <Route path="/callcenter/request" element={<RequestNumberPage />} />
                    <Route path="/callcenter/port" element={<PortNumberPage />} />
                    <Route path="/callcenter/change" element={<ChangeNumberPage />} />
                    <Route path="/timesheetmanager" element={<TimesheetManager />} />
                    <Route path="/leavemanager" element={<LeaveManager />} />
                  </Route>

                  <Route path="/myreimbursements" element={<ViewReimbursements my="my" />} />
                  <Route path="/viewreimbursements" element={<ViewReimbursements my="" />} />


                  <Route path="/opensettings" element={<OpenSettingsCard {...props} user={props.user} token={token} role={role} additionalUserInfo={additionalUserInfo} setAdditionalUserInfo={setAdditionalUserInfo} setRole={setRole} />} />

                  <Route path="/clientchatview" element={<ChatView type="c" />} additionalUserInfo={additionalUserInfo} />
                  <Route path="/solverchatview" element={<ChatView type="s" />} additionalUserInfo={additionalUserInfo} />
                  <Route path="/kbchatview" element={<KbChatView type="s" />} additionalUserInfo={additionalUserInfo} />
                  <Route path="/aichat" element={<AIChatView />} />
                  <Route path="/inddocprocessing" element={<IndDocumentProcessing />}/>
                  <Route path="/trade-job-dashboard" element={<TradeJobDashboard />} />
                  <Route path="/trade-job-calendar" element={<TradeJobCalendarPage />} />
                  <Route path="/trade-job-create" element={<TradeJobCreatePage />} />
                  <Route path="/onboarding/me" element={<OnboardingDetailPage />} />
                  <Route path="/onboarding/:employeeId" element={<OnboardingDetailPage />} />
                  <Route path="/inventory" element={<InventoryManagement />} />
                  <Route path="/inventory/search" element={<InventorySearch />} />
                  <Route path="/inventory/add" element={<AddInventory />} />
                  <Route path="/inventory/aicheck" element={<AIInventoryCheck />} />
                  <Route path="/customer" element={<CustomerManagement />} />
                  <Route path="/customer/search" element={<CustomerSearch />} />
                  <Route path="/customer/add" element={<AddCustomer />} />
                  <Route path="/my-profile" element={<MyProfilePage />} />
                  <Route path="/my-profile/calendar" element={<MyProfileCalendarPage />} />
                  <Route path="/flexible-employment/create-job" element={<CreateEmploymentJobPage />} />
                  <Route path="/flexible-employment/jobs" element={<EmployerEmploymentJobsPage />} />
                  <Route path="/employment-jobs/:jobId/apply" element={<EmploymentJobApplyPage />} />
 
                </Routes>
                {determinePage()}



              </div>
              <div className="footer">
                <a href="./privacy.html">Privacy</a><br />
                <a href="./support.html">Contact us or Support</a><br />
                <a href="./disclaimer.html">Disclaimer</a><br />
                &copy; All Rights Reserved</div>
            </div>

            <Dialog
              open={showAppDownloadPopup}
              onClose={() => setShowAppDownloadPopup(false)}
              aria-labelledby="app-download-dialog-title"
              maxWidth="sm"
              fullWidth
              PaperProps={{
                sx: {
                  borderRadius: '18px',
                  overflow: 'hidden',
                  minHeight: '420px',
                  background: 'linear-gradient(160deg, #0f172a 0%, #1e293b 55%, #334155 100%)',
                  color: '#f8fafc'
                }
              }}
            >
              <DialogTitle
                id="app-download-dialog-title"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  pt: 3,
                  pb: 1,
                  fontWeight: 700,
                  fontSize: '1.6rem'
                }}
              >
                <IoLogoApple size={34} />
                Get the iPhone App
              </DialogTitle>
              <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  Effiez Roster Shift Planner
                </Typography>
                <Typography variant="body1" sx={{ opacity: 0.95, lineHeight: 1.7 }}>
                  Download Effiez all in one HR and Trade Job Management tool on the Apple App Store for a better experience.
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.85 }}>
                  Fast access to your roster, shifts, and updates while you are on the go.
                </Typography>
              </DialogContent>
              <DialogActions sx={{ px: 3, pb: 3, pt: 1, justifyContent: 'space-between' }}>
                <Button onClick={() => setShowAppDownloadPopup(false)} sx={{ color: '#e2e8f0' }}>
                  Close
                </Button>
                <Button
                  variant="contained"
                  startIcon={<IoLogoApple />}
                  onClick={() => setShowAppDownloadPopup(false)}
                  href="https://apps.apple.com/au/app/effiez-roster-shift-planner/id6670292224"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    bgcolor: '#f8fafc',
                    color: '#0f172a',
                    fontWeight: 700,
                    px: 2.5,
                    '&:hover': {
                      bgcolor: '#e2e8f0'
                    }
                  }}
                >
                  Download Now
                </Button>
              </DialogActions>
            </Dialog>

            <GuidedTourModal
              open={showGuidedTour}
              onClose={() => setShowGuidedTour(false)}
              userRole={role}
              userId={guidedTourUserId}
            />


          </div>

        </div>
      </AuthProvider>

    </StyledEngineProvider>
  );

}

//export default withAuthenticator(App, { hideSignUp: false });
